export type ClusterJobProgressStage =
  | 'loading_items'
  | 'grouping'
  | 'persisting'
  | 'finalizing';

export const CLUSTER_JOB_STAGE_LABELS: Record<ClusterJobProgressStage, string> = {
  loading_items: 'Scanning General items',
  grouping: 'Finding groups',
  persisting: 'Saving suggestions',
  finalizing: 'Finishing up',
};

const UNKNOWN_STAGE_LABEL = 'Preparing scan';

export function getClusterJobStageLabel(stage: string | null | undefined): string {
  if (!stage) {
    return UNKNOWN_STAGE_LABEL;
  }
  if (stage in CLUSTER_JOB_STAGE_LABELS) {
    return CLUSTER_JOB_STAGE_LABELS[stage as ClusterJobProgressStage];
  }
  return UNKNOWN_STAGE_LABEL;
}

export function formatClusterJobProgressSuffix(metrics?: Record<string, unknown>): string {
  if (!metrics) {
    return '';
  }
  const scanned = metrics.work_items_scanned;
  if (typeof scanned === 'number' && Number.isFinite(scanned) && scanned > 0) {
    return ` (${scanned} scanned)`;
  }
  return '';
}

export function formatClusterJobStatusMessage(
  stage: string | null | undefined,
  metrics?: Record<string, unknown>,
): string {
  return `${getClusterJobStageLabel(stage)}${formatClusterJobProgressSuffix(metrics)}`;
}

const ACTIVE_JOB_STATUSES = new Set(['queued', 'running']);
const TERMINAL_JOB_STATUSES = new Set(['completed', 'failed']);

export function isActiveClusterJobStatus(status: string | null | undefined): boolean {
  return Boolean(status && ACTIVE_JOB_STATUSES.has(status));
}

export function isTerminalClusterJobStatus(status: string | null | undefined): boolean {
  return Boolean(status && TERMINAL_JOB_STATUSES.has(status));
}

type ClusterJobLike = { status: string } | null | undefined;

/** Resolve hydrate job: active first, else last failed terminal (mirrors sync resolveRowSyncJob). */
export function resolveClusterJobContext(
  activeJob: ClusterJobLike,
  lastTerminalJob: ClusterJobLike,
): ClusterJobLike {
  if (activeJob) {
    return activeJob;
  }
  if (lastTerminalJob?.status === 'failed') {
    return lastTerminalJob;
  }
  return null;
}
